// src/stores/jsonStore.js
import { defineStore } from 'pinia';

export const useJsonStore = defineStore('jsonList', {
    state: () => ({
        domainData: null,
        ossList: null,
        provinceOssList: null,
        config: null,
        userPower: null,
        userAgreement:''
    }),
    actions: {
        setKey(key, value) {
            this[key] = value
        },
    },
    getters:{
        getDomain(){
            return this.domainData
        },
        getUserAgreement(){
            return this.userAgreement
        },
        getOssList(){
            return this.ossList
        },
        getUserPower(){
            return this.userPower
        },
        getProvinceOssList(){
            return this.provinceOssList
        },
        getConfig(){
            return this.config
        }
    },
    persist: false
});
